/* istanbul ignore file: Directive */
'use strict';

/**
 * Focuses an element when a given expression evaluates to true.
 * It also injects an 'updateFocus' function in the current form controller.
 * This function will find the first element for which ngFocus is true and
 * focus it.
 */
customerZone.directive('ngFocus', [function() {
    return {
        require: '^form',
        link: function(scope, elem, attrs, ctrl){
            var focusFunction = function () {
                if (scope.$eval(attrs.ngFocus)){
                    setTimeout(function(){
                        elem.focus();
                    }, 10);
                }
            };
            scope.$watch(attrs.ngFocus, focusFunction);
            ctrl.updateFocus = function(){
                var $candidates = ctrl.$$element
                    .find('input[ng-focus]')
                    .filter(function(){
                        return scope.$parent.$eval($(this).attr('ng-focus'));
                    });
                $candidates.push(ctrl.$$element.find('[tabindex]'));
                $candidates
                    .first().focus();

            };
        }
    };
}]);
